/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Badge_FallbackInputs */

const en_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Library`)
};

const es_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteca`)
};

const de_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliothek`)
};

const zh_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习库`)
};

const ar_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المكتبة`)
};

const fr_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliothèque`)
};

const vi_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thư viện`)
};

const sw_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maktaba`)
};

const th_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คลังแบบฝึก`)
};

const bs_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteka`)
};

const ja_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブラリー`)
};

const ko_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라이브러리`)
};

const pt_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteca`)
};

const it_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteca`)
};

const sv_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliotek`)
};

const nl_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliotheek`)
};

const da_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliotek`)
};

const nb_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliotek`)
};

const fi_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjasto`)
};

const pl_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteka`)
};

const ru_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Библиотека`)
};

const tr_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kütüphane`)
};

const hi_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुस्तकालय`)
};

const id_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pustaka`)
};

const ms_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pustaka`)
};

const cs_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knihovna`)
};

const el_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Βιβλιοθήκη`)
};

const he_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ספרייה`)
};

const af_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteek`)
};

const hu_practice_badge_fallback = /** @type {(inputs: Practice_Badge_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Könyvtár`)
};

/**
* | output |
* | --- |
* | "Library" |
*
* @param {Practice_Badge_FallbackInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_badge_fallback = /** @type {((inputs?: Practice_Badge_FallbackInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Badge_FallbackInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_badge_fallback(inputs)
	if (locale === "de") return de_practice_badge_fallback(inputs)
	if (locale === "zh") return zh_practice_badge_fallback(inputs)
	if (locale === "ar") return ar_practice_badge_fallback(inputs)
	if (locale === "fr") return fr_practice_badge_fallback(inputs)
	if (locale === "vi") return vi_practice_badge_fallback(inputs)
	if (locale === "sw") return sw_practice_badge_fallback(inputs)
	if (locale === "th") return th_practice_badge_fallback(inputs)
	if (locale === "bs") return bs_practice_badge_fallback(inputs)
	if (locale === "ja") return ja_practice_badge_fallback(inputs)
	if (locale === "ko") return ko_practice_badge_fallback(inputs)
	if (locale === "pt") return pt_practice_badge_fallback(inputs)
	if (locale === "it") return it_practice_badge_fallback(inputs)
	if (locale === "sv") return sv_practice_badge_fallback(inputs)
	if (locale === "nl") return nl_practice_badge_fallback(inputs)
	if (locale === "da") return da_practice_badge_fallback(inputs)
	if (locale === "nb") return nb_practice_badge_fallback(inputs)
	if (locale === "fi") return fi_practice_badge_fallback(inputs)
	if (locale === "pl") return pl_practice_badge_fallback(inputs)
	if (locale === "ru") return ru_practice_badge_fallback(inputs)
	if (locale === "tr") return tr_practice_badge_fallback(inputs)
	if (locale === "hi") return hi_practice_badge_fallback(inputs)
	if (locale === "id") return id_practice_badge_fallback(inputs)
	if (locale === "ms") return ms_practice_badge_fallback(inputs)
	if (locale === "cs") return cs_practice_badge_fallback(inputs)
	if (locale === "el") return el_practice_badge_fallback(inputs)
	if (locale === "he") return he_practice_badge_fallback(inputs)
	if (locale === "af") return af_practice_badge_fallback(inputs)
	if (locale === "hu") return hu_practice_badge_fallback(inputs)
	return en_practice_badge_fallback(inputs)
});